import { render, staticRenderFns } from "./DealerWarning.vue?vue&type=template&id=fe31c3fe"
import script from "./DealerWarning.vue?vue&type=script&lang=js"
export * from "./DealerWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports